import { ActionIcon, Tooltip, useMantineColorScheme } from "@mantine/core";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import Icon from "@/utils/icons";

export const ColorSchemeSwitch = () => {
  const { t } = useTranslation();
  const { colorScheme, setColorScheme } = useMantineColorScheme();

  const details = useMemo(() => {
    switch (colorScheme) {
      case "auto":
        return {
          icon: <Icon.AUTOMODE />,
          tooltip: t("automode"),
        };
      case "dark":
        return {
          icon: <Icon.DARKMODE />,
          tooltip: t("darkmode"),
        };
      case "light":
        return { icon: <Icon.LIGHTMODE />, tooltip: t("lightmode") };
    }
  }, [t, colorScheme]);

  const cycleToggleColorScheme = () => {
    if (colorScheme === "auto") setColorScheme("dark");
    if (colorScheme === "dark") setColorScheme("light");
    if (colorScheme === "light") setColorScheme("auto");
  };

  return (
    <Tooltip label={details.tooltip}>
      <ActionIcon variant="subtle" radius="xl" onClick={cycleToggleColorScheme}>
        {details.icon}
      </ActionIcon>
    </Tooltip>
  );
};

export default ColorSchemeSwitch;
